export default "__VITE_ASSET__POt6fuoW__"